var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Box, Button, CircularProgress, Input } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { Auth } from "aws-amplify";
import React from "react";
import "../styles/AuthStylesheet.css";
import maternaTheme from "../styles/materna_theme";
import AuthComponent, { STATE_SIGN_UP_CONFIRM, STATE_SIGNED_UP } from "./AuthComponent";
import { FormattedMessage, injectIntl } from "react-intl";
var VERIFICATION_CODE_LENGTH = 6;
var ERRORCODE_INVALID_CODE = "CodeMismatchException";
var VALID_AUTH_STATES = [STATE_SIGN_UP_CONFIRM];
var SignupConfirmationComponent = /** @class */ (function (_super) {
    __extends(SignupConfirmationComponent, _super);
    function SignupConfirmationComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            confirmationCode: "",
            infoMessage: "",
            errorMessage: "",
            loading: false,
            buttonEnabled: false
        };
        _this.handleCodeChange = _this.handleCodeChange.bind(_this);
        _this.resendCode = _this.resendCode.bind(_this);
        _this.onCodeSubmit = _this.onCodeSubmit.bind(_this);
        _this.intl = props.intl;
        return _this;
    }
    SignupConfirmationComponent.prototype.getValidAuthStates = function () {
        return VALID_AUTH_STATES;
    };
    SignupConfirmationComponent.prototype.renderComponent = function () {
        var _this = this;
        return (React.createElement(ThemeProvider, { theme: maternaTheme },
            React.createElement("div", { className: "container" },
                React.createElement("h3", { className: "auth-headline-small" },
                    React.createElement(FormattedMessage, { id: "authentication-signup_confirmation-header" })),
                React.createElement("form", { autoComplete: "off", onSubmit: function (e) { return e.preventDefault(); } },
                    React.createElement("div", null,
                        React.createElement("label", { className: "label" },
                            React.createElement(FormattedMessage, { id: "authentication-signup_confirmation-confirmation_code" })),
                        React.createElement(Box, { width: 300 },
                            React.createElement(Input, { className: "input", fullWidth: true, value: this.state.confirmationCode, onChange: function (evt) { return _this.handleCodeChange(evt.target.value); }, type: "text", placeholder: this.intl.formatMessage({ id: "authentication-signup_confirmation-confirmation_code" }), required: true })))),
                React.createElement("p", { className: "auth-link", onClick: this.resendCode },
                    React.createElement(FormattedMessage, { id: "authentication-signup_confirmation-request_code-cta" })),
                React.createElement("div", { className: "message" },
                    this.renderLoading(),
                    this.renderInfo(),
                    this.renderError()),
                React.createElement(Box, { display: "flex", justifyContent: "center" },
                    React.createElement(Button, { variant: "contained", color: "primary", disabled: !this.state.buttonEnabled, className: "button", onClick: this.onCodeSubmit },
                        React.createElement(FormattedMessage, { id: "authentication-signup_confirmation-submit" }))))));
    };
    SignupConfirmationComponent.prototype.renderLoading = function () {
        if (!this.state.loading) {
            return null;
        }
        return (React.createElement("span", { style: {
                display: "flex",
                alignItems: "center"
            } },
            React.createElement(CircularProgress, { className: "progress", color: "inherit", size: 20 }),
            React.createElement(FormattedMessage, { id: "authentication-signup_confirmation-processing_message" })));
    };
    SignupConfirmationComponent.prototype.renderInfo = function () {
        if (this.state.infoMessage === "") {
            return null;
        }
        return (React.createElement("p", { className: "auth-info" }, this.state.infoMessage));
    };
    SignupConfirmationComponent.prototype.renderError = function () {
        if (this.state.errorMessage === "") {
            return null;
        }
        return (React.createElement("p", { className: "error" }, this.state.errorMessage));
    };
    SignupConfirmationComponent.prototype.onCodeSubmit = function () {
        var _this = this;
        this.setState({
            errorMessage: "",
            infoMessage: "",
            loading: true,
            buttonEnabled: false
        });
        Auth.confirmSignUp(this.props.authData.username.toLowerCase(), this.state.confirmationCode)
            .then(function () {
            _this.changeAuthState(STATE_SIGNED_UP);
        })
            .catch(function (err) {
            console.error(err);
            _this.setState({
                loading: false,
                buttonEnabled: true,
                infoMessage: "",
                errorMessage: _this.getMessageForError(err)
            });
        });
    };
    SignupConfirmationComponent.prototype.resendCode = function () {
        var _this = this;
        this.setState({ loading: true });
        Auth.resendSignUp(this.props.authData.username)
            .then(function () {
            _this.setState({
                loading: false,
                errorMessage: "",
                infoMessage: _this.intl.formatMessage({ id: "authentication-signup_confirmation-request_code-message" })
            });
        })
            .catch(function (err) {
            _this.setState({
                loading: false,
                infoMessage: "",
                errorMessage: _this.getMessageForError(err)
            });
        });
    };
    SignupConfirmationComponent.prototype.handleCodeChange = function (code) {
        var regex = RegExp("^[0-9]*$");
        if (!regex.test(code)) {
            return;
        }
        this.setState({
            buttonEnabled: code.length === VERIFICATION_CODE_LENGTH,
            confirmationCode: code
        });
    };
    SignupConfirmationComponent.prototype.getMessageForError = function (err) {
        if (err.code === ERRORCODE_INVALID_CODE) {
            return this.intl.formatMessage({ id: "authentication-signup_confirmation-error-code_invalid" });
        }
        return this.intl.formatMessage({ id: "authentication-default_error_message" }, { errMsg: err.message });
    };
    return SignupConfirmationComponent;
}(AuthComponent));
export { SignupConfirmationComponent };
export default injectIntl(SignupConfirmationComponent);
//# sourceMappingURL=SignUpConfirmationComponent.js.map